import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Sandwich } from "lucide-react";

export default function ProtectedRoute({ children, role, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  // checking session
  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F9F6F0] text-[#1A1A1A]">
        <div className="animate-pulse h-12 w-12 rounded-lg bg-[#C85A32] flex items-center justify-center mb-3">
          <Sandwich className="h-6 w-6 text-[#F9F6F0]" />
        </div>
        <div className="text-sm text-[#8C8C8C]">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const allowed = roles ?? (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to={defaultHomeFor(user.role)} replace />;
  }

  return children;
}

export function defaultHomeFor(role) {
  switch (role) {
    case "admin":
      return "/admin";
    case "encargado":
      return "/admin/pedidos";
    case "repartidor":
    case "elaborador":
      return "/staff";
    case "cliente":
      return "/cliente";
    default:
      return "/login";
  }
}
